Ext.define('SA.view.scatterplot.ScatterPlotPointsGroup', {
    constructor({parent}) {
        this.el = parent.appendChild(document.createElementNS('http://www.w3.org/2000/svg', 'g'));
    },

    getPointCount() {
        return this.el.querySelectorAll('.sa-scatter-plot-point').length;
    },

    render({data, onClick, onMouseOut, onMouseOver, pointColor, pointRadius, pointStroke, pointStrokeWidth, xAttribute, xScale, yAttribute, yScale}) {
        var pointsByPosition = new Map();

        this.el.innerHTML = '';

        this.el.setAttributeNS(null, 'fill', pointColor);
        this.el.setAttributeNS(null, 'stroke', pointStroke);
        this.el.setAttributeNS(null, 'stroke-width', pointStrokeWidth);

        this.el.onclick = wrapPointEventHandler(onClick);
        this.el.onmouseover = wrapPointEventHandler(onMouseOver);
        this.el.onmouseout = wrapPointEventHandler(onMouseOut);

        data.forEach(d => {
            var cx = xScale(d[xAttribute]),
                cy = yScale(d[yAttribute]),
                position = `(${cx},${cy})`,
                point = pointsByPosition.get(position);

            if (!point) {
                point = this.el.appendChild(document.createElementNS('http://www.w3.org/2000/svg', 'circle'));

                point.classList.add('sa-scatter-plot-point');
                point.data = [];

                point.setAttributeNS(null, 'cx', cx);
                point.setAttributeNS(null, 'cy', cy);
                point.setAttributeNS(null, 'r', pointRadius);

                pointsByPosition.set(position, point);
            }

            point.data.push(d);
        });

        function wrapPointEventHandler(handler) {
            return ({target}) => {
                if (target.matches('.sa-scatter-plot-point')) {
                    handler(target.data, target);
                }
            };
        }
    }
});